import React from 'react';

export const FileXLS = React.memo(() => (
  <>
    <defs>
      <linearGradient
        gradientUnits='userSpaceOnUse'
        id='linear-gradient-xls'
        x1='6.65'
        x2='27.27'
        y1='6.65'
        y2='27.27'
      >
        <stop offset='0' stopColor='#00916e' />
        <stop offset='1' stopColor='#007758' />
      </linearGradient>
      <linearGradient
        id='linear-gradient-xls-2'
        x1='6'
        x2='12'
        xlinkHref='#linear-gradient-xls'
        y1='5'
        y2='5'
      />
    </defs>
    <path
      fill={'url(#linear-gradient-xls)'}
      d='M23.5,2h-12a.47.47,0,0,0-.35.15l-5,5A.47.47,0,0,0,6,7.5v20A2.5,2.5,0,0,0,8.5,30h15A2.5,2.5,0,0,0,26,27.5V4.5A2.5,2.5,0,0,0,23.5,2Z'
    />
    <path
      fill={'url(#linear-gradient-xls-2)'}
      d='M11.69,2a.47.47,0,0,0-.54.11l-5,5A.47.47,0,0,0,6,7.69.5.5,0,0,0,6.5,8h3A2.5,2.5,0,0,0,12,5.5v-3A.5.5,0,0,0,11.69,2Z'
    />
    <path
      fill={'#f8edeb'}
      d='M12.66,11a.49.49,0,0,0-.63.31l-1,3.08-1-3.08a.5.5,0,1,0-.94.32L10.47,16,9,20.34a.49.49,0,0,0,.31.63.45.45,0,0,0,.16,0,.49.49,0,0,0,.47-.34l1-3.08,1,3.08a.49.49,0,0,0,.47.34.45.45,0,0,0,.16,0,.49.49,0,0,0,.31-.63L11.53,16,13,11.66A.49.49,0,0,0,12.66,11Z'
    />
    <path
      fill={'#f8edeb'}
      d='M17.5,20H15V11.5a.5.5,0,0,0-1,0v9a.5.5,0,0,0,.5.5h3a.5.5,0,0,0,0-1Z'
    />
    <path
      fill={'#f8edeb'}
      d='M21.5,15.5h-1A.5.5,0,0,1,20,15V12.5a.5.5,0,0,1,.5-.5h2a.5.5,0,0,0,0-1h-2A1.5,1.5,0,0,0,19,12.5V15a1.5,1.5,0,0,0,1.5,1.5h1a.5.5,0,0,1,.5.5v2.5a.5.5,0,0,1-.5.5h-2a.5.5,0,0,0,0,1h2A1.5,1.5,0,0,0,23,19.5V17A1.5,1.5,0,0,0,21.5,15.5Z'
    />
  </>
));
FileXLS.displayName = 'FileXLS';
